class FileSelectDirective {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                file: '=',              // Two-way bound file
                onFileSelected: '&?',   // Optional callback
                hint: '@?',             // Optional hint text
                accept: '@?'            // Accept string (e.g. ".psd,.zip")
            },
            templateUrl: 'components/file-uploader/file-select.html',
            link: (scope, element) => {
                scope.dragOver = false;
                scope.error = null;

                const uploadArea = element[0].querySelector('.upload-area');
                const input = element[0].querySelector('input[type=file]');
                scope.fileInput = input;

                const parseAcceptTypes = (acceptString) => {
                    if (!acceptString) return [];
                    return acceptString.split(',').map(ext => ext.trim().toLowerCase());
                };

                const allowedExtensions = parseAcceptTypes(scope.accept);
                const maxSize = 10 * 1024 * 1024 * 1024; //1GB

                const validateFile = (file) => {
                    if (!file) return 'No file selected.';
                    if (allowedExtensions.length > 0) {
                        const ext = '.' + file.name.split('.').pop().toLowerCase();
                        if (!allowedExtensions.includes(ext)) {
                            return 'Invalid file type';
                        }
                    }
                    if (file.size > maxSize) return 'File size must be under 10MB.';
                    return null;
                };

                scope.triggerFileInput = () => {
                    scope.fileInput?.click();
                };

                scope.clearFile = () => {
                    scope.file = null;
                    scope.error = null;
                    if (scope.fileInput) {
                        scope.fileInput.value = '';
                    }
                };

                input.addEventListener('change', (e) => {
                    const selectedFile = e.target.files[0];
                    scope.$apply(() => {
                        const error = validateFile(selectedFile);
                        scope.error = error;
                        scope.file = error ? null : selectedFile;
                        if (!error && scope.onFileSelected) {
                            scope.onFileSelected({ file: selectedFile });
                        }
                    });
                });

                uploadArea.addEventListener('dragover', (e) => {
                    e.preventDefault();
                    scope.$apply(() => scope.dragOver = true);
                });

                uploadArea.addEventListener('dragleave', (e) => {
                    e.preventDefault();
                    scope.$apply(() => scope.dragOver = false);
                });

                uploadArea.addEventListener('drop', (e) => {
                    e.preventDefault();
                    const droppedFile = e.dataTransfer.files[0];
                    scope.$apply(() => {
                        scope.dragOver = false;
                        const error = validateFile(droppedFile);
                        scope.error = error;
                        scope.file = error ? null : droppedFile;
                        if (!error && scope.onFileSelected) {
                            scope.onFileSelected({ file: droppedFile });
                        }
                    });
                });

                scope.$watch('file', (newVal) => {
                    if (!newVal && scope.fileInput) {
                        scope.fileInput.value = '';
                    }
                });
            }
        };
    }
}

angular.module('cpm')
    .directive('fileSelect', [() => new FileSelectDirective()]);
